import { en } from "./en";
import { ar } from "./ar";

export const translations = { en, ar };
export { en, ar };
